import { useAuth } from "context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useCheckMenuPermission } from "./useCheckMenuPermission";
import { useCallback } from "react";
import tabs from "components/subTabs-items/tabs";

export function useRedirectFromProjects() {
    const { user } = useAuth();
    const navigate = useNavigate();
    const { hasRoleCheck } = useCheckMenuPermission();
    const encrypt = (text) => btoa(unescape(encodeURIComponent(text)));

    const handleClick = useCallback(
        (val, p) => {            
            const permissions = p?.flatMap(mod => mod?.permissions || []);            
            const projectPage = tabs?.filter(
                (item) => item?.permissionKey?.some((name) => permissions?.includes(name)) > 0 || hasRoleCheck() > 0
            );
            if (projectPage?.length > 0) {
                navigate(`/projects/${val}?type=${projectPage?.[0]?.path}`);
                localStorage.setItem("projectUrl", encrypt(projectPage?.[0]?.path));
            } else {
                 navigate(`/projects/${val}/my-work`);
            }
        },
        [user,navigate]
    );

    return handleClick;
}
